import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1 21.3a2 2 0 0 0 3.2 0c.5-.6.7-1.4.6-2.1l-.6-3.1h3.3c1.3 0 2.3-.8 2.9-1.8.5-1 .7-2.2.2-3.5l-2.6-7C18.8 2.8 18 2 16.7 2H8.6C7 2 6 3.4 6 4.9V14a3 3 0 0 0 .8 2l5.3 5.2Zm1.6-1.3a1 1 0 0 0-.1-.1l-5.4-5.1A1 1 0 0 1 8 14V5c0-.7.4-.9.6-.9h8.1c.2 0 .4.1.6.5l2.6 7c.2.7.1 1.3-.2 1.8-.2.5-.7.8-1 .8H14a1 1 0 0 0-1 1.1l.8 4.3a.6.6 0 0 1-.1.4l-.1.1Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 13a3 3 0 1 0 6 0V5a3 3 0 0 0-6 0v8Zm3 1a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1Z"
    />
  </>,
  'ThumbsDown'
)
